import api from './api';

export interface PrivacyPolicy {
  id: number;
  title: string;
  content: string;
  version: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TermsAndConditions {
  id: number;
  title: string;
  content: string;
  version: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLegalDocumentRequest {
  title: string;
  content: string;
  version: string;
}

export interface UpdateLegalDocumentRequest {
  title?: string;
  content?: string;
  version?: string;
  isActive?: boolean;
}

class LegalService {
  // Privacy Policy endpoints
  async getActivePrivacyPolicy(): Promise<PrivacyPolicy | null> {
    try {
      const response = await api.api.get('/legal/privacy-policy');
      return response.data.data || null;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getAllPrivacyPolicies(): Promise<PrivacyPolicy[]> {
    const response = await api.api.get('/legal/privacy-policy/all');
    return response.data.data || [];
  }

  async createPrivacyPolicy(data: CreateLegalDocumentRequest): Promise<PrivacyPolicy> {
    const response = await api.api.post('/legal/privacy-policy', data);
    return response.data.data;
  }

  async updatePrivacyPolicy(id: number, data: UpdateLegalDocumentRequest): Promise<PrivacyPolicy> {
    const response = await api.api.put(`/legal/privacy-policy/${id}`, data);
    return response.data.data;
  }

  // Terms and Conditions endpoints
  async getActiveTermsAndConditions(): Promise<TermsAndConditions | null> {
    try {
      const response = await api.api.get('/legal/terms-and-conditions');
      return response.data.data || null;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getAllTermsAndConditions(): Promise<TermsAndConditions[]> {
    const response = await api.api.get('/legal/terms-and-conditions/all');
    return response.data.data || [];
  }

  async createTermsAndConditions(data: CreateLegalDocumentRequest): Promise<TermsAndConditions> {
    const response = await api.api.post('/legal/terms-and-conditions', data);
    return response.data.data;
  }

  async updateTermsAndConditions(id: number, data: UpdateLegalDocumentRequest): Promise<TermsAndConditions> {
    const response = await api.api.put(`/legal/terms-and-conditions/${id}`, data);
    return response.data.data;
  }
}

export default new LegalService();